export const COOKIE = {
  CLOUD_CALLBACK_URI: 'vodori.cloud.callback.uri',
  CLOUD_JWT: 'vodori.cloud.jwt',
  CLOUD_MOST_RECENT_PATH: 'vodori.cloud.mostRecentPath',
  CLOUD_TNTS: 'vodori.cloud.tnts',
  CLOUD_ACTING_VIRTUAL_USER_ID: 'vodori.cloud.actingVirtualUserId',
}

export const STORAGE = {
  FORCE_RELOAD: 'vodori-force-reload',
  IDLE_EXPIRY: 'ng2Idle.main.expiry',
}
